<template>
    <nav
        v-if="state"
        class="AlgoliaSearchCategories"
    >
        <ul
            class="container"
        >
            <!-- <li
                :class="{'is-refined' : !unrefined }"
            >
                <slot />
            </li> -->

            <li
                v-for="item in excludeEvents"
                :key="item.value"
                :class="{'is-disabled' : item.count === 0, 'is-refined' : item.isRefined}"
            >
                <button
                    class="SearchFilter"
                    @click="refine(item)"
                >
                    <span>
                        <figure class="circle" />
                        <strong class="mr-min">{{ item.label }}</strong>
                        {{ item.count }}
                    </span>
                    <BaseIcon
                        icon="chevron-down-icon"
                        class="hide--lap-and-up"
                    />
                </button>


                <ul
                    v-if="item.isRefined"
                    class="hide--lap-and-up bg--grey-light pl-medium py-small"
                >
                    <li
                        v-for="child in item.data"
                        :key="child.value"
                        :class="{'is-refined' : child.isRefined}"
                    >
                        <button
                            class="SearchFilter SearchFilter--child"
                            @click="state.refine(child.value)"
                        >
                            <span>
                                <figure class="circle" />
                                <strong class="mr-min">{{ child.label }}</strong>
                                {{ child.count }}
                            </span>
                        </button>
                    </li>
                </ul>
            </li>
        </ul>
        <AlgoliaSearchSubcategories
            :items="refinedItemSubcategories"
            :refine="state.refine"
        />
    </nav>
</template>
<script>
import { createWidgetMixin } from 'vue-instantsearch';
import { connectHierarchicalMenu } from 'instantsearch.js/es/connectors'

export default {
    name: 'AlgoliaSearchCategories',
    mixins: [
        createWidgetMixin({ connector: connectHierarchicalMenu })
    ],
    props: {
        attributes: {
            type: Array,
            required: true,
        },
    },
    computed: {
        widgetParams() {
            return {
                attributes: this.attributes,
                limit: 20,
            }
        },
        refinedItemSubcategories() {
            const refinedItem = this.state.items.filter((item) => item.isRefined === true)
            return refinedItem.length ? refinedItem[0].data : null
        },
        excludeEvents() {
            return this.state.items.filter((item) => item.label != 'Events');
        }
        // unrefined() {
        //     return this.items.filter((item) => item.isRefined).length
        // }
    },
    methods: {
        refine(item) {
            if (item.count !== 0) {
                this.state.refine(item.value)
            }
        },
    }
}
</script>
<style lang="scss" scoped>
    .AlgoliaSearchCategories {
        background: $action-color;

        @include media-query(palm) {
            margin: 0 1.5rem;
            box-shadow: 0 15px 25px 0 rgba(0,0,0,0.20);
            border-radius: 2px;
        }

    }
    ul {

        @include media-query(lap-and-up) {
            display: flex;
            align-items: center;
        }

        @include media-query(palm) {
            padding: 0;
        }

        li {

            @include media-query(lap-and-up) {
                display: flex;
                align-items: center;
                padding: getSpacing(small) 0;

                &.is-refined {
                    position: relative;

                    &:after {
                        content: '';
                        position: absolute;
                        width: 0;
                        height: 0;
                        border-left: 15px solid transparent;
                        border-right: 15px solid transparent;
                        border-top: 15px solid $action-color;
                        bottom: -8px;
                        left: 50%;
                        margin-left: -15px;
                    }

                }
            }

            > ul > li {
                @include media-query(palm) {
                    width: 100%;
                    padding: 0.5rem 1.5rem;
                }
            }
        }
    }

    .SearchFilter {
        color: getColor('white');
        font-size: 15px;

        @include media-query(lap-and-up) {
            padding: 6px 15px;
            border-radius: 50px;
            background: transparent;
        }

        @include media-query(palm) {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            padding: 1rem 1.5rem;
            border-bottom: 1px solid rgba(getColor('white'), 0.4);

            li:last-child & {
                border: 0;
            }
        }

        .is-refined & {
            @include media-query(lap-and-up) {
                background: getColor('lightblue');
            }
        }

        .BaseIcon {
            font-size: 14px;

            .is-refined & {
                transform: rotate(180deg);
            }
        }

        > span {
            @include media-query(palm) {
                display: flex;
                align-items: center;
            }
        }

        .circle {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 20px;
            height: 20px;
            border-radius: 50%;
            margin-right: 1rem;
            border: 2px solid getColor('lightblue');

            &:after {
                content: "\2713";
                font-weight: bold;
                font-size: 20px;
                position: relative;
                top: -3px;
                opacity: 0;

            }

            @include media-query(lap-and-up) {
                display: none;
            }
        }
    }

    .SearchFilter--child {
        color: $action-color;
        width: auto;
        padding: 6px 15px;
        border-radius: 50px;
        background: transparent;
        border: 0;

        .is-refined >& {
            background: getColor('sand');
            color: getColor('white');
        }

        .circle {
            border-color: getColor('sand');
        }
    }
</style>
